class GoogleMap {
  constructor(el, options) {
    this.scope = el;
    this.buildMap(options);
    this.infoWindow;
    this.bindClick = e => {
      if (e.target.closest('[role="dialog"]') === null) {
        if (e.target.closest('[title="map-pin"]') === null) {
          this.infoWindow.close();
        } else {
          document.removeEventListener("click", this.bindClick);
        }
      }
    };
  }

  async buildMap(options) {
    
    const minZoom = 11;
    
    const icon = {
      url: "images/map-single-pin.svg", // url
      scaledSize: new google.maps.Size(42, 42), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(25, 25) // anchor
    };

    const infowindow = new google.maps.InfoWindow({
      content: ''
    });
    let locations = options && options.locations ? await options.locations : await getMapData();
 
    let bounds = new google.maps.LatLngBounds();
    locations.locations.forEach(location => {
        if ((location.latitude <= 90 && location.latitude >= -90) && (location.longitude <= 180 && location.longitude >= -180)){
            let loc = new google.maps.LatLng(location.latitude, location.longitude);
            bounds.extend(loc);            
        }
    });

    let map = new google.maps.Map(
        this.scope, {
          zoom: minZoom,
          center: locations[0],
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: options && options.fullscreenControl ? options.fullscreenControl : false,
          zoomControl:  options && options.zoomControl ? options.zoomControl : false
        });
    
    map.fitBounds(bounds);
    map.panToBounds(bounds);
    
    //if only 1 location prevent zooming all the way in
    locations.locations.length === 1 && google.maps.event.addListenerOnce(map, "bounds_changed", function () {
      this.setZoom(minZoom+2);
    });
    
    this.infoWindow = infowindow;

    let coords = [];
      const markers = locations.locations.map(location => {
      const center = [location.latitude, location.longitude];
      const marker = new google.maps.Marker({
        id: location.nodeId,
        position: {lat: location.latitude, lng: location.longitude},
        content: location,
        map: map,
        icon: "/images/map-single-pin.svg"
      });
      coords.push(center);
      marker.addListener('click', () => openInfoWindow(marker, center));
      return marker;
    });
    
    
    const openInfoWindow = (marker, latLong) =>{
        fetch('/Umbraco/surface/Locations/GetLocation?id=' + marker.id)
          .then(response => response.text())
          .then(data => {
            infowindow.setContent(data);
            infowindow.open(map, marker);

          })
          .then(() => {
              const closeButton = document.querySelector('.map-info__close');
              if (closeButton){
                  closeButton.addEventListener('click', () => {
                      infowindow.close();
                  });                  
              }
          })
          .then(() => {
              const directionsButton = document.querySelector(".map-info [data-get-directions]");
              if (directionsButton){
                  directionsButton.addEventListener('click', () => {
                      LocationBlock.getDirections(latLong);
                  });                  
              }
          })
    }
    setTimeout(()=>{
        options && options.openWindow && openInfoWindow(markers[0], coords[0]);
    }, 300)
    
    if(locations.length > 1){
        const cluster = new markerClusterer.MarkerClusterer({markers, map});
    }
  }
}

function getMapData(){
  const locationsList = document.querySelector('[data-locations]');
  let ids = '';
  if (locationsList){
      ids = locationsList.dataset.locations;
  }
  return fetch(`/Umbraco/surface/Locations/GetLocations?ids=${ids}`)
      .then(response => response.json())
      .then(data => {
          return data;
      })
      .catch(err => {
          return [];
      });
}

ControlBinders.register(`[data-map]`, el => new GoogleMap(el));